import React from "react";
import { Delete, Done } from "@material-ui/icons";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";
import CloseIcon from "@material-ui/icons/Close";

import { ButtonIcon } from "../../../../../../../../components/Buttons/ButtonIcon/ButtonIcon";
import { availableBlockSelectorActionCodes } from "../../../../constants";

import styles from "./styles.module.scss";

const DataSelectorList = ({
    activeData,
    newData,
    dataSelectors,
    onSaveSelectors,
    onEditSelectors,
    onDeleteDataSelector,
    onViewSelector
}) => (
    <ul className={styles.listWrapper}>
        {
            dataSelectors.map((item, index) => {
                const { name, is_required, selectors, action_code } = item;

                if(!availableBlockSelectorActionCodes.includes(action_code)) {
                    return null;
                }

                return (
                    <li
                        key={index}
                        className={styles.list}
                    >
                        <div className={styles.listMain}>
                            <div className={styles.listName}>{`${name || ""}${is_required ? " - required" : ""}`}</div>

                            <div className={styles.controlsItem}>
                                {
                                    !onSaveSelectors && !newData && (
                                        <ButtonIcon
                                            onClick={() => onViewSelector(item, index)}
                                            disabled={activeData && name !== activeData.name}
                                        >
                                            {
                                                activeData && name === activeData.name ? (
                                                    <CloseIcon/>
                                                ) : (
                                                    <VisibilityIcon />
                                                )
                                            }
                                        </ButtonIcon>
                                    )
                                }

                                {
                                    onSaveSelectors && (
                                        <ButtonIcon
                                            success
                                            onClick={onSaveSelectors}
                                            title="Done"
                                        >
                                            <Done />
                                        </ButtonIcon>
                                    )
                                }

                                {
                                    onEditSelectors && (
                                        <ButtonIcon
                                            onClick={() => onEditSelectors(item, index)}
                                            title="Edit"
                                        >
                                            <EditIcon/>
                                        </ButtonIcon>
                                    )
                                }

                                <ButtonIcon
                                    warning
                                    onClick={() => onDeleteDataSelector(index)}
                                    title={"Delete"}
                                >
                                    <Delete/>
                                </ButtonIcon>
                            </div>
                        </div>

                        {selectors?.map(({ selector }, index) => (
                            <div
                                className={styles.xpath}
                                key={index}
                            >
                                    - {selector}
                            </div>
                        ))}
                    </li>
                );
            })
        }
    </ul>
);

export default DataSelectorList;
